import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import { RouteName } from './utils/routeName';
import { generateRoutes } from './utils/route';
import { Register } from './components/Register';
import { ChangePassword } from './components/ChangePassword';
import ResetPasswordRouting from './components/ResetPassword/ResetPasswordRouting';
import { SplitHome } from './components/SplitHome/SplitHome';
import { SplitHomeSelection } from './components/SplitHomeSelection';

const Router = () => {
  const { t } = useTranslation(['global', 'routerName']);

  const routes = [
    {
      title: t('register'),
      key: 'register',
      link: RouteName.register,
      component: <Register />,
    },
    {
      title: t('Change Password'),
      key: 'changePassword',
      link: RouteName.changePassword,
      component: <ChangePassword />,
    },
    {
      title: t('resetpassword'),
      key: 'resetpassword',
      link: RouteName.resetpassword,
      component: <ResetPasswordRouting />,
    },
    {
      title: t('splitHome'),
      key: 'splitHome',
      link: RouteName.splitHome,
      component: <SplitHome />,
    },
    {
      title: t('splitHomeSelection'),
      key: 'splitHomeSelection',
      link: RouteName.splitHomeSelection,
      component: <SplitHomeSelection />,
    },
    {
      title: t('register'),
      key: 'registerOne',
      link: RouteName.registerOne,
      component: <Register />,
    },
    {
      title: t('register'),
      key: 'registerTwo',
      link: RouteName.registerTwo,
      component: <Register />,
    },
    {
      title: t('register'),
      key: 'registerThree',
      link: RouteName.registerThree,
      component: <Register />,
    },
    {
      title: t('register'),
      key: 'registerFour',
      link: RouteName.registerFour,
      component: <Register />,
    },
    {
      title: t('register'),
      key: 'registerFive',
      link: RouteName.registerFive,
      component: <Register />,
    },
    {
      title: t('register'),
      key: 'registerSix',
      link: RouteName.registerSix,
      component: <Register />,
    },

  ];

  return (
    <>
      {/** ALL ROUTES */}
      {generateRoutes(routes)}
      <Route exact path="/">
        <Register />
      </Route>

    </>
  );
};

export default Router;
